import { Injectable } from '@angular/core';
import { ExternalMetricTypesService } from '../services/external-metric-types-service';
import { AdsMetricTypeNames, ExternalMetricType } from '../types/external-metrics.types';
import { GoogleAdsDataService } from './google-ads-data.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleAdsMetricTypesService extends ExternalMetricTypesService {
  externalMetricTypes = [
    {
      type: ExternalMetricType.int,
      name: AdsMetricTypeNames.IMPRESSIONS,
      label: 'Impressions',
      description: 'How often your ads were shown'
    },
    {
      type: ExternalMetricType.int,
      name: AdsMetricTypeNames.CLICKS,
      label: 'Clicks',
      description: 'Actions on your ads'
    },
    {
      type: ExternalMetricType.int,
      name: AdsMetricTypeNames.CONVERSIONS,
      label: 'Conversions',
      description: 'Actions on your website from ads'
    },
  ];
  defaultMapping = {
    [AdsMetricTypeNames.IMPRESSIONS]: 'Impressions',
    [AdsMetricTypeNames.CLICKS]: 'Clicks',
    [AdsMetricTypeNames.CONVERSIONS]: 'Conversions',
  };

  constructor(
    private readonly googleAdsDataService: GoogleAdsDataService
  ) {
    super(googleAdsDataService);
  }
}
